import React from 'react';
import { Box, Container, Stack, Typography, Card, Grid, AppBar, Toolbar } from '@mui/material';
import Logo from 'components/Logo';
import SocialsButton from 'components/SocialsButton';
import { useNavigate } from 'react-router-dom';
import { alpha, styled } from '@mui/material/styles';
import useAuth from 'hooks/useAuth';
import NotificationsPopover from './NotificationsPopover';
import AccountPopover from './AccountPopover';
import MessagePopover from './MessagePopover';
import Searchbar from './Searchbar';

const POLICIES = [
  {
    name: 'Privacy Policy',
    link: '/privacy-policy'
  },
  {
    name: 'Terms Of Service',
    link: '/terms-of-service'
  }
];

const textStyle = {
  fontWeight: '700',
  lineHeight: '1.7142857142857142',
  fontSize: '0.975rem',
  textTransform: 'capitalize',
  minWidth: '64px',
  color: '#212B36'
};

const DRAWER_WIDTH = 280;
const COLLAPSE_WIDTH = 102;

const APPBAR_MOBILE = 36;
const APPBAR_DESKTOP = 0;

const RootStyle = styled(AppBar)(({ theme }) => ({
  //   boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  bottom: 'auto',
  top: '0',
  justifyContent: 'space-between',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  boxShadow: '0 0 2px 0 rgba(145, 158, 171, 0.24),0 16px 32px -4px rgba(145, 158, 171, 0.24)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`
  },
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0.4, 1)
  }
}));

// const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
//   minHeight: APPBAR_MOBILE,
//   [theme.breakpoints.up('lg')]: {
//     minHeight: APPBAR_DESKTOP,
//     padding: theme.spacing(0, 0)
//   }
// }));

function HeaderNavbar() {
  const { user = {} } = useAuth();
  const navigate = useNavigate();

  const onBtExit = (policy) => {
    window.open(`https://www.serviceplug.in${policy.link}`, '_blank');
  };
  return (
    <RootStyle>
      {/* <ToolbarStyle> */}
      <Stack
        direction="row"
        alignItems="flex-start"
        sx={{ ...textStyle, fontWeight: 500, mt: 1, ml: { md: '254px', sm: 0, xs: 0 } }}
      >
        {user.role === 'OEM' && (
          <Stack flexDirection="row">
            <Typography sx={{ fontSize: '0.75rem', fontWeight: '600' }}>
              Email : <span>support@serviceplug.in</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Mobile : <span>6360586465</span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Time : <span>10:00am to 6pm (Monday to Saturday)</span>
            </Typography>
          </Stack>
        )}
        {/* Powered by ServicePlug Technology Pvt Ltd */}
        {/* <Searchbar /> */}
      </Stack>
      {/* <SocialsButton sx={{ mx: 0.2 }} /> */}
      <Stack direction="row" alignItems="flex-start" sx={{ ml: 3 }}>
        {/* <MessagePopover /> */}
        {/* <NotificationsPopover /> */}
        <AccountPopover />
      </Stack>
      {/* </ToolbarStyle> */}
    </RootStyle>
  );
}

export default HeaderNavbar;
